import { endpoints } from '../api/sharedEndpoints';
import type {
  EventActionResponse,
  EventCancelResponse,
  EventCreateRequest,
  EventDto,
  EventUpdateRequest,
  EventsListResponse,
} from '../api/types';

export interface EventsRepository {
  getEvent(params: { eventId: string }): Promise<EventDto>;
  listEventsRange(params: { from: string; to: string }): Promise<EventsListResponse>;
  listEventsDate(params: { date: string }): Promise<EventsListResponse>;

  createEvent(params: { payload: EventCreateRequest }): Promise<EventDto>;
  updateEvent(params: { eventId: string; payload: EventUpdateRequest }): Promise<EventDto>;
  cancelEvent(params: { eventId: string }): Promise<EventCancelResponse>;

  joinEvent(params: { eventId: string }): Promise<EventActionResponse>;
  leaveEvent(params: { eventId: string }): Promise<EventActionResponse>;
  confirmEvent(params: { eventId: string }): Promise<EventActionResponse>;

  inviteToEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto>;
  inviteGroupToEvent(params: { eventId: string; groupId: string }): Promise<EventDto>;
  removeFromEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto>;
  unreserveFromEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto>;
}

export class ApiEventsRepository implements EventsRepository {
  async getEvent(params: { eventId: string }): Promise<EventDto> {
    return endpoints.getEvent(params.eventId);
  }

  async listEventsRange(params: { from: string; to: string }): Promise<EventsListResponse> {
    return endpoints.listEventsRange(params.from, params.to);
  }

  async listEventsDate(params: { date: string }): Promise<EventsListResponse> {
    return endpoints.listEventsDate(params.date);
  }

  async createEvent(params: { payload: EventCreateRequest }): Promise<EventDto> {
    return endpoints.createEvent(params.payload);
  }

  async updateEvent(params: { eventId: string; payload: EventUpdateRequest }): Promise<EventDto> {
    return endpoints.updateEvent(params.eventId, params.payload);
  }

  async cancelEvent(params: { eventId: string }): Promise<EventCancelResponse> {
    return endpoints.cancelEvent(params.eventId);
  }

  async joinEvent(params: { eventId: string }): Promise<EventActionResponse> {
    return endpoints.joinEvent(params.eventId);
  }

  async leaveEvent(params: { eventId: string }): Promise<EventActionResponse> {
    return endpoints.leaveEvent(params.eventId);
  }

  async confirmEvent(params: { eventId: string }): Promise<EventActionResponse> {
    return endpoints.confirmEvent(params.eventId);
  }

  async inviteToEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto> {
    return endpoints.inviteToEvent(params.eventId, params.telegramIds);
  }

  async inviteGroupToEvent(params: { eventId: string; groupId: string }): Promise<EventDto> {
    return endpoints.inviteGroupToEvent(params.eventId, params.groupId);
  }

  async removeFromEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto> {
    return endpoints.removeFromEvent(params.eventId, params.telegramIds);
  }

  async unreserveFromEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto> {
    return endpoints.unreserveFromEvent(params.eventId, params.telegramIds);
  }
}
